/**
 * Rudi's emails link to `/?rudiThread=<id>` (ADR 0058). The root route
 * redirects to Home and a sign-in may come first, so the id waits in
 * sessionStorage until the signed-in Rudi panel can open the thread.
 */
const KEY = 'rudi:pending-thread';
const PARAM = 'rudiThread';
const THREAD_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function capturePendingRudiThread(location: Location = window.location): void {
  const params = new URLSearchParams(location.search);
  const threadId = params.get(PARAM);
  if (threadId === null) return;
  if (THREAD_ID.test(threadId)) sessionStorage.setItem(KEY, threadId);
  params.delete(PARAM);
  const search = params.toString();
  window.history.replaceState(
    window.history.state,
    '',
    `${location.pathname}${search ? `?${search}` : ''}${location.hash}`
  );
}

export function takePendingRudiThread(): string | null {
  const threadId = sessionStorage.getItem(KEY);
  if (threadId !== null) sessionStorage.removeItem(KEY);
  return threadId;
}
